<template>
  <div v-if="!isMobile()">
    <div
      class="section section-blockchain"
      id="blockchain-section"
      data-background-color="black"
    >
      <div
        data-aos="fade-right"
        data-aos-offset="-500"
        class="img_deco_01"
      ></div>
      <div class="container text-center">
        <h3 data-aos="fade-up" data-aos-offset="-500" class="title deco2">
          {{ $t(`Blockchain Features`) }}
        </h3>
        <div class="space-50"></div>
        <div class="row" style="padding-bottom: 60px">
          <div
            data-aos="fade-right"
            data-aos-offset="-100"
            class="col-md-6"
            style="padding: 0"
          >
            <img v-lazy="'/img/img_game_04.png'" width="100%" height="100%" />
          </div>
          <div
            data-aos="fade-left"
            data-aos-offset="-100"
            class="col-md-6"
            style="
              background-image: url('/img/bg_game_01.png');
              min-height: 220px;
              background-size: cover;
              background-repeat: no-repeat;
            "
          >
            <div
              class="img_deco_05"
              style="background-image: url(/img/img_deco_04.png)"
            />
            <h5
              class="description-game-title text-left"
              style="padding-left: 20px; padding-top: 50px"
            >
              <img v-lazy="'/img/icon_info.png'" style="padding-bottom: 5px" />
              {{ $t(`menu_land`) }}
            </h5>
            <h5
              class="description-game-desc text-left"
              style="padding-left: 20px"
            >
              {{ $t(`land desc`) }}
            </h5>
            <div
              style="
                position: absolute;
                background-image: url(/img/btn_main_03.png);
                background-size: 100% 100%;
                background-repeat: no-repeat;
                left: 110px;
                bottom: 10px;
                width: 360px;
                height: 60px;
                cursor: pointer;
                padding-top: 10px;
                text-transform: uppercase;
                font-size: 20px !important;
                font-weight: 600;
                font-stretch: normal;
                font-style: normal;
                text-align: center;
                color: #ffffff;
              "
              @click="goDetail(0)"
            >
              {{ $t("detail") }}
            </div>
          </div>
        </div>
        <div class="row" style="padding-bottom: 60px">
          <div
            data-aos="fade-right"
            data-aos-offset="-200"
            class="col-md-6"
            style="padding: 0"
          >
            <img v-lazy="'/img/img_game_05.png'" width="100%" height="100%" />
          </div>
          <div
            data-aos="fade-left"
            data-aos-offset="-200"
            class="col-md-6"
            style="
              background-image: url('/img/bg_game_01.png');
              min-height: 220px;
              background-size: cover;
              background-repeat: no-repeat;
            "
          >
            <img class="img_deco_05" src="/img/img_deco_04.png" />
            <h5
              class="description-game-title text-left"
              style="padding-left: 20px; padding-top: 50px"
            >
              <img v-lazy="'/img/icon_info.png'" style="padding-bottom: 5px" />
              {{ $t(`menu_drago`) }}
            </h5>
            <h5
              class="description-game-desc text-left"
              style="padding-left: 20px"
            >
              {{ $t(`drago_description`) }}
            </h5>
            <div
              style="
                position: absolute;
                background-image: url(/img/btn_main_03.png);
                background-size: 100% 100%;
                background-repeat: no-repeat;
                left: 110px;
                bottom: 10px;
                width: 360px;
                height: 60px;
                cursor: pointer;
                padding-top: 10px;
                text-transform: uppercase;
                font-size: 20px !important;
                font-weight: 600;
                font-stretch: normal;
                font-style: normal;
                text-align: center;
                color: #ffffff;
              "
              @click="goDetail(1)"
            >
              {{ $t("detail") }}
            </div>
          </div>
        </div>
        <div class="row" style="padding-bottom: 60px">
          <div
            data-aos="fade-right"
            data-aos-offset="-300"
            class="col-md-6"
            style="padding: 0"
          >
            <img v-lazy="'/img/img_game_06.png'" width="100%" height="100%" />
          </div>
          <div
            data-aos="fade-left"
            data-aos-offset="-300"
            class="col-md-6"
            style="
              background-image: url('/img/bg_game_01.png');
              min-height: 220px;
              background-size: cover;
              background-repeat: no-repeat;
            "
          >
            <img class="img_deco_05" src="/img/img_deco_04.png" />
            <h5
              class="description-game-title text-left"
              style="padding-left: 20px; padding-top: 50px"
            >
              <img v-lazy="'/img/icon_info.png'" style="padding-bottom: 5px" />
              {{ $t(`menu_arena`) }}
            </h5>
            <h5
              class="description-game-desc text-left"
              style="padding-left: 20px"
            >
              {{ $t(`arena_description`) }}
            </h5>
            <div
              style="
                position: absolute;
                background-image: url(/img/btn_main_03.png);
                background-size: 100% 100%;
                background-repeat: no-repeat;
                left: 110px;
                bottom: 10px;
                width: 360px;
                height: 60px;
                cursor: pointer;
                padding-top: 10px;
                text-transform: uppercase;
                font-size: 20px !important;
                font-weight: 600;
                font-stretch: normal;
                font-style: normal;
                text-align: center;
                color: #ffffff;
              "
              @click="goDetail(2)"
            >
              {{ $t("detail") }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div
      class="section-m section-blockchain"
      id="blockchain-section"
      data-background-color="black"
    >
      <div class="img_deco_01"></div>
      <div class="container" style="width: 85%">
        <h3 class="title-m deco1">{{ $t(`Blockchain Features`) }}</h3>
        <div class="row" style="padding-bottom: 0px">
          <div class="col-md-6" style="padding: 0">
            <img v-lazy="'/img/img_game_04.png'" width="100%" height="100%" />
          </div>
          <div
            class="col-md-6"
            style="
              margin-top: -25px;
              background-image: url('/img/bg_game_01.png');
              min-height: 260px;
              background-size: cover;
              background-repeat: no-repeat;
            "
          >
            <h5
              class="description-game-title-m text-left"
              style="padding-left: 0px; padding-top: 40px"
            >
              <img v-lazy="'/img/icon_info.png'" style="padding-bottom: 5px" />
              {{ $t(`menu_land`) }}
            </h5>
            <h5
              class="description-game-desc-m text-left"
              style="padding-left: 0px"
            >
              {{ $t(`land desc`) }}
            </h5>
            <div
              style="
                position: absolute;
                background-image: url(/img/btn_main_03.png);
                background-size: 100% 100%;
                background-repeat: no-repeat;
                left: 15%;
                bottom: 10px;
                width: 70%;
                height: 60px;
                cursor: pointer;
                padding-top: 10px;
                text-transform: uppercase;
                font-size: 20px !important;
                font-weight: 600;
                font-stretch: normal;
                font-style: normal;
                text-align: center;
                color: #ffffff;
              "
              @click="goDetail(0)"
            >
              {{ $t("detail") }}
            </div>
          </div>
        </div>
        <div class="row" style="padding-bottom: 0px">
          <div class="col-md-6" style="padding: 0">
            <img v-lazy="'/img/img_game_05.png'" width="100%" height="100%" />
          </div>
          <div
            class="col-md-6"
            style="
              margin-top: -25px;
              background-image: url('/img/bg_game_01.png');
              min-height: 260px;
              background-size: cover;
              background-repeat: no-repeat;
            "
          >
            <h5
              class="description-game-title-m text-left"
              style="padding-left: 0px; padding-top: 40px"
            >
              <img v-lazy="'/img/icon_info.png'" style="padding-bottom: 5px" />
              {{ $t(`menu_drago`) }}
            </h5>
            <h5
              class="description-game-desc-m text-left"
              style="padding-left: 0px"
            >
              {{ $t(`drago_description`) }}
            </h5>
            <div
              style="
                position: absolute;
                background-image: url(/img/btn_main_03.png);
                background-size: 100% 100%;
                background-repeat: no-repeat;
                left: 15%;
                bottom: 10px;
                width: 70%;
                height: 60px;
                cursor: pointer;
                padding-top: 10px;
                text-transform: uppercase;
                font-size: 20px !important;
                font-weight: 600;
                font-stretch: normal;
                font-style: normal;
                text-align: center;
                color: #ffffff;
              "
              @click="goDetail(1)"
            >
              {{ $t("detail") }}
            </div>
          </div>
        </div>
        <div class="row" style="padding-bottom: 0px">
          <div class="col-md-6" style="padding: 0">
            <img v-lazy="'/img/img_game_06.png'" width="100%" height="100%" />
          </div>
          <div
            class="col-md-6"
            style="
              margin-top: -25px;
              background-image: url('/img/bg_game_01.png');
              min-height: 260px;
              background-size: cover;
              background-repeat: no-repeat;
            "
          >
            <h5
              class="description-game-title-m text-left"
              style="padding-left: 0px; padding-top: 40px"
            >
              <img v-lazy="'/img/icon_info.png'" style="padding-bottom: 5px" />
              {{ $t(`menu_arena`) }}
            </h5>
            <h5
              class="description-game-desc-m text-left"
              style="padding-left: 0px"
            >
              {{ $t(`arena_description`) }}
            </h5>
            <div
              style="
                position: absolute;
                background-image: url(/img/btn_main_03.png);
                background-size: 100% 100%;
                background-repeat: no-repeat;
                left: 15%;
                bottom: 10px;
                width: 70%;
                height: 60px;
                cursor: pointer;
                padding-top: 10px;
                text-transform: uppercase;
                font-size: 20px !important;
                font-weight: 600;
                font-stretch: normal;
                font-style: normal;
                text-align: center;
                color: #ffffff;
              "
              @click="goDetail(2)"
            >
              {{ $t("detail") }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    goDetail(idx) {
      switch (idx) {
        case 0:
          this.$router.push("/land");
          break;
        case 1:
          this.$router.push("/drago");
          break;
        case 2:
          this.$router.push("/arena");
          break;
      }
    },
  },
};
</script>
<style></style>
